const createPartnerForm = document.querySelector('#registerPartner');
const createPartnerBtn = createPartnerForm?.querySelector('.partner-join-signin-link.create');
const createNewPartnerForm = document.querySelector('#create_customer');
const returnTo = createNewPartnerForm?.querySelector('input[name="return_to"]');

// #region create buttons

createPartnerBtn?.addEventListener('click', async () => {
  if (createPartnerForm.querySelector('.alert')) {
    createPartnerForm.querySelectorAll('.alert').forEach((elm) => elm.remove());
  }

  const inputs = createPartnerForm.querySelectorAll('input');
  const selectedPaymentMethod = document.querySelector('.product-payment-method--select').value;
  const checkboxes = Array.from(inputs).filter(input => input.type === "checkbox" && input.className != "switch__input");
  let checked = true;

  checkboxes.forEach(checkbox => {
    if (!checkbox.checked) {
      checked = false;
    }
  });

  if (!checked) {
    showValidationError("checkbox", "existing");
    return;
  }

  const variantId = Array.from(inputs).find((input) => input.getAttribute('name') === 'variant-id').value;
  const sellingPlanId = Array.from(inputs).find((input) => input.getAttribute('name') === 'selling-plan-id').value;
  const discountValue = Array.from(inputs).find((input) => input.getAttribute("name") === "discount-value").value;
  const isManualPayment = KROWN.settings.manualPaymentTypes.includes(selectedPaymentMethod);

  const updates = {};
  updates['' + variantId] = 0;

  const item = {
    id: variantId,
    quantity: 1,
    selling_plan: isManualPayment ? '' : sellingPlanId
  };

  if (isManualPayment) {
    item.properties = { 
      _sellingplan: sellingPlanId,
      _discountvalue: discountValue,
    };
  }

  const formData = {
    attributes: { "_paymentMethod": selectedPaymentMethod },
    items: [item]
  };

  // show loader
  createPartnerBtn.classList.add('display-none');
  createPartnerBtn.closest('.partner-join-form-btn').classList.add('no-click');
  createPartnerBtn.closest('.partner-join-form-btn').querySelector('.partner-loader').classList.remove('display-none');

  await fetch(`${KROWN.settings.routes.cart_update_url}.js`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ updates })
  }).catch((error) => {
    console.error(error);
  });

  await fetch(`${KROWN.settings.routes.cart_add_url}.js`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  }).catch((error) => {
    console.error(error);
  });

  // refresh cart after adding
  await refreshCartForPartner();

  // checkout
  document.querySelector('.checkout-btn').click();
  createPartnerBtn.closest('.partner-join-form-btn').querySelector('.partner-loader').classList.add('display-none');
  createPartnerBtn.classList.remove('display-none');
  createPartnerBtn.closest('.partner-join-form-btn').classList.remove('no-click');
});

createNewPartnerForm?.addEventListener('submit', function (event) {
  if (createNewPartnerForm.querySelector('.alert')) {
    createNewPartnerForm.querySelectorAll('.alert').forEach((elm) => elm.remove());
  }

  const inputs = createNewPartnerForm.querySelectorAll('input');

  const inputFields = Array.from(inputs).filter(input => input.classList.contains('form-input-field'));
  const checkboxes = Array.from(inputs).filter(input => input.type === "checkbox" && input.className != "switch__input");

  const passwordLength = document.querySelector('#password').value.trim().length;

  let filled = true;
  let checked = true;

  inputFields.forEach(inputField => {
    if (inputField.id !== "customer-registration-tags" && inputField.value.trim() === "") {
      filled = false;
    }
  });

  if (!filled) {
    event.preventDefault();
    showValidationError("input", "new");
    return;
  }

  checkboxes.forEach(checkbox => {
    if (!checkbox.checked) {
      checked = false;
    }
  });

  if (!checked) {
    event.preventDefault();
    showValidationError("checkbox", "new");
    return;
  }

  if (passwordLength < 5 || passwordLength > 40) {
    event.preventDefault();
    showValidationError("password", "new");
    return;
  }

  window.sessionStorage.setItem('customerRegistrationSession', 'true');
  const associatedPartnerId = window.getAssociatedPartnerId()
  if (associatedPartnerId) {
    console.log(`Partner association during registration: ${associatedPartnerId}`);
    document.querySelector("#customer-registration-tags").value = `comsysPartnerId:${associatedPartnerId}`;
  } else {
    console.log('Partner association is missing');
  }
});

// #endregion

// #region gocardless

// on page load
document.addEventListener('DOMContentLoaded', () => {
  // auto selecting the value of the payment method dropdown
  const preselectedPaymentMethod = document.querySelector('.cart__payment-method').innerText;
  if (preselectedPaymentMethod !== '' && preselectedPaymentMethod !== undefined) {
    document.querySelector('#bundle-payment-method').value = document.querySelector('.cart__payment-method').innerText;
  } else {
    document.querySelector('#bundle-payment-method').options[0].selected = true;
  }

  updateReturnValue();
});

// show modal to update payment type
document.querySelector('#bundle-payment-method').addEventListener('change', () => {
  const currentPaymentMethodTypeInCart = document.querySelector('.cart__payment-method').innerHTML;
	const paymentMethodSelected = document.querySelector('.product-payment-method--select').value;
  updateReturnValue();
  if (
		!!currentPaymentMethodTypeInCart &&
	  currentPaymentMethodTypeInCart !== paymentMethodSelected
  ) {
		document.getElementById("gocardlessModal").show();
	}
});

// calling clear cart api on click of yes in payment method reset in modal
document.querySelector('.cta-yes').addEventListener('click', async () => {
  document.querySelector(".cta-no").classList.add('no-click');
  document.querySelector(".cta-yes").classList.add('no-click');
  document.querySelector(".cta-yes .button-text").classList.add('visibility-hidden');
  document.querySelector(".cta-yes .button-loader-container").classList.remove('visibility-hidden');

  await fetch(KROWN.settings.routes.cart_clear_url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/javascript'
    }
  }).catch((e) => {
    console.log(e);
  });

  await refreshCartForPartner().then(() => {
    document.getElementById('gocardlessModal').hide();

    document.querySelector(".cta-no").classList.remove('no-click');
    document.querySelector(".cta-yes").classList.remove('no-click');
    document.querySelector(".cta-yes .button-text").classList.remove('visibility-hidden');
    document.querySelector(".cta-yes .button-loader-container").classList.add('visibility-hidden');
  });
});

// changing the payment method to the previously selected one on click of No button in modal
document.querySelector('.cta-no').addEventListener('click', () => {
  handleCloseAction();
});

// changing the payment method to the previously selected one on closing the modal
document.querySelector('#gocardlessModal .modal-close').addEventListener('click', () => {
  handleCloseAction();
});

// changing the payment method to the previously selected one
const handleCloseAction = () => {
  const paymentMethodType = document.querySelector('.cart__payment-method').innerHTML;
  const selectedOption = document.querySelector('.product-payment-method--select');
  selectedOption.value = KROWN.settings.manualPaymentTypes.includes(paymentMethodType) 
    ? paymentMethodType
    : selectedOption?.options[0]?.value;

  updateReturnValue();
};

// #endregion

// #region helper methods

// update value for return_to input field
const updateReturnValue = () => {
  if (returnTo) {
    returnTo.value =
      returnTo.value.split('&paymentMethod')[0] +
      "&paymentMethod=" +
      document.querySelector('#bundle-payment-method').value;
  }
}

// function to dynamically add and append alerts
const showValidationError = (errorType, formType) => {
  const errorParent = document.createElement('span');
  const errorSymbol = document.createElement('span');
  const errorTextContainer = document.createElement('span');

  errorParent.classList.add('alert', 'alert--error', 'alert--icon');
  errorSymbol.classList.add('alert__icon');

  errorSymbol.innerHTML = KROWN.settings.symbols.alert_icon;

  switch (errorType) {
    case "input":
      errorTextContainer.innerHTML = KROWN.settings.partner_form_input_error;
      break;

    case "checkbox":
      errorTextContainer.innerHTML = KROWN.settings.partner_form_checkbox_error;
      break;

    case "password":
      errorTextContainer.innerHTML = KROWN.settings.partner_form_password_error;
      break;
  }

  errorParent.append(errorSymbol);
  errorParent.append(errorTextContainer);

  let form = undefined;
  let firstNode = undefined;

  switch (formType) {
    case "existing":
      form = document.querySelector('.partner-join-form');
      firstNode = document.querySelector('.bundle-payment-method');
      break;

    case "new":
      form = createNewPartnerForm;
      firstNode = document.querySelector('.partner-join-form__row');
      break;
  }

  form.insertBefore(errorParent, firstNode);
};

// refresh cart
const refreshCartForPartner = async () => {
  await fetch('?section_id=helper-cart')
    .then((response) => response.text())
    .then((text) => {
      const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
      const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
      const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

      const cartItems = document.getElementById('AjaxCartForm');
      cartItems.innerHTML = cartFormInnerHTML;
      cartItems.ajaxifyCartItems();

      document.querySelectorAll('[data-header-cart-count]').forEach((elm) => {
        elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
      });

      document.querySelectorAll('[data-header-cart-total').forEach((elm) => {
        elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
      });

      document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;

      if (document.querySelector('cart-recommendations')) {
        document.querySelector('cart-recommendations').innerHTML = '';
        document.querySelector('cart-recommendations').generateRecommendations();
      }
    })
    .catch((error) => {
      console.error(error);
    });
};

// #endregion
